import {Auth} from 'aws-amplify';
import {
  logoutUser,
  clearPublicUser,
  clearAppointmentBookingDetails,
  clearClassBookingDetails,
  updateLogoutMessage,
} from '../redux/actions'; // adjust the paths
import {store} from '../redux/configureStore'; // the store where your Redux is set up
import localforage from 'localforage';

const PERSIST_KEY = 'persist:root';

const persistAssistantContextOnly = async assistantContext => {
  const persisted = await localforage.getItem(PERSIST_KEY);
  let data = {};

  if (persisted) {
    try {
      data = JSON.parse(persisted);
    } catch (error) {
      data = {};
    }
  }

  const nextData = {
    _persist: data._persist || JSON.stringify({version: -1, rehydrated: true}),
    assistantContext: JSON.stringify(assistantContext || {}),
  };

  await localforage.setItem(PERSIST_KEY, JSON.stringify(nextData));
};

export const handleLogout = async (message = null) => {
  try {
    await Auth.signOut();
    // Dispatch actions to clear the Redux store
    store.dispatch(logoutUser());
    store.dispatch(clearPublicUser());
    store.dispatch(clearAppointmentBookingDetails());
    store.dispatch(clearClassBookingDetails());
    store.dispatch(updateLogoutMessage(message));
    const assistantContext = store.getState()?.assistantContext;
    await persistAssistantContextOnly(assistantContext);
    localStorage.clear();
    // Redirect to login
    window.location.replace('/login');
  } catch (error) {
    console.error('Error during logout:', error);
  }
};
